export const actionTypes = {
    fetchOrder: 'FETCH_ORDER',
    receiveOrder: 'RECEIVE_ORDER',
    createOrder:'CREATE_ORDER',
    updateOrder:'UPDATE_ORDER',
    clearOrder : 'CLEAR_ORDER',
    setOrder:'SET_ORDER',
    addStudy:'ADD_STUDY',
    editStudy:'EDIT_STUDY',
    removeStudy:'REMOVE_STUDY',
    clearStudies:'CLEAR_STUDIES'
};

export const clearOrder = { type: actionTypes.clearOrder };

